import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom';
import { AppBar, Avatar, Button, Card, CardActions, CardContent, CardMedia, Container, Grid, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, ThemeProvider, Toolbar, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send'
import { ListItemIcon } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { IconButton } from '@mui/material';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import { Box } from '@mui/system';
import {theme} from './components/mytheme';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Watch } from 'react-loader-spinner';

// https://www.choco-recipe.jp/milk/
// https://oceans-nadia.com/special_sites/valentine


function NavAppBar() {
  return (
    <Box sx={{flexGrow: 1}}>
        <ThemeProvider theme={theme}>
      <AppBar position='static' color='secondary'>
        <Toolbar variant='dense'>
          <IconButton edge="start" color="inherit" aria-label='home' sx={{mr:2}}>
            <HomeButton />
          </IconButton>
          <Typography variant='h6' color="inherit" conponent="div">教えて、手作りチョコレシピ！</Typography>
        </Toolbar>
      </AppBar>
      </ThemeProvider>
    </Box>
  );
}

function App() {
  return (
    <>
      <NavAppBar />
      <br />
      <Container maxWidth="md">
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<SelectLevel />} />
          <Route path="/situation" element={<SelectSituation />} />
          <Route path="/cooktime" element={<SelectCookTime />} />
          <Route path="/result" element={<Result />} />
        </Routes>
        </BrowserRouter>
      </Container>
    </>
  );
}

function HomeButton() {
  return (
    <IconButton conponent="a" href="/">
      <HomeIcon />
    </IconButton>
  );
}

function SelectItem(props) {
  return (
    <div>
      <ListItem>
        <ListItemButton component="a" href={props.link}>
          <ListItemIcon>
            <SendIcon />
          </ListItemIcon>
          {props.message}
        </ListItemButton>
      </ListItem>
    </div>
  );
}

function SelectLevel() {
  return (
    <div>
      <Typography variant="h5" color="inherit" conponent="div">レシピの難易度を選んでね</Typography>
      <List>
        <SelectItem link="/situation?level=1" message="初めて作ります" />
        <SelectItem link="/situation?level=2" message="初心者です" />
        <SelectItem link="/situation?level=3" message="中級者です" />
        <SelectItem link="/situation?level=4" message="上級者です" />
      </List>
    </div>
  );
}

function SelectSituation() {
  const [searchParams, ] = useSearchParams();
  const level = searchParams.get("level")

  return (
    <div>
      <Typography variant="h5" color="inherit" conponent="div">渡す相手を選んでね</Typography>
      <List>
        <SelectItem link={`/cooktime?level=${level}&situation=std`} message="定番チョコ" />
        <SelectItem link={`/cooktime?level=${level}&situation=honmei`} message="本命チョコ" />
        <SelectItem link={`/cooktime?level=${level}&situation=friend`} message="友チョコ" />
        <SelectItem link={`/cooktime?level=${level}&situation=party`} message="会社/学校" />
      </List>
    </div>
  );
}

function SelectCookTime() {
  const [searchParams, ] = useSearchParams();
  const level = searchParams.get("level")
  const situation = searchParams.get("situation")

  return (
    <div>
      <Typography variant="h5" color="inherit" conponent="div">調理時間を選んでね</Typography>
      <List>
        <SelectItem link={`result?level=${level}&situation=${situation}&cookTimeRange=0-30`} message="30分以内" />
        <SelectItem link={`result?level=${level}&situation=${situation}&cookTimeRange=31-60`} message="30～60分" />
        <SelectItem link={`result?level=${level}&situation=${situation}&cookTimeRange=61-90`} message="60～90分" />
        <SelectItem link={`result?level=${level}&situation=${situation}&cookTimeRange=91`} message="それ以上" />
      </List>
    </div>
  );
}

function ResultRecipe(props) {
  const hitRecipe = props.hitRecipe
  return (
    <Grid item xs={6}>
    <Card sx={{maxWidth: 445}}>
      <CardMedia
        component="img"
        height="140"
        image={hitRecipe.img}
        alt="img"
      />
      <CardContent>
        <Typography gutterBottom variant='h5' conponent="div">{hitRecipe.title}</Typography>
        <Typography variant="body2" color="text.secondary">
          <List sx={{width: "100%", maxWidth: 360, bgcolor: "Background.paper"}}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <SchoolIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="難易度" secondary={hitRecipe.levelText} />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="シチュエーション" secondary={hitRecipe.situationText} />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AccessAlarmIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="調理時間" secondary={hitRecipe.cookTime} />
            </ListItem>
          </List>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {hitRecipe.point}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" href={hitRecipe.link} target="_blank">レシピを詳しく見る</Button>
      </CardActions>
    </Card>
    </Grid>
  );  
}

function Result() {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, ] = useSearchParams();
  const level = Number(searchParams.get("level"))
  const situation = searchParams.get("situation")
  const cookTimeRange = searchParams.get("cookTimeRange")

  const url = "https://script.google.com/macros/s/AKfycbzYnl0MwaLQnPaMf5wUJXWSAxlBttVZlEVhHRkeD_8lfq7-S2MylAJ6wOR6886nWFHOWQ/exec"
  useEffect(() => {
    async function fetchData() {
      const response = await axios.get(url);
      setRecipes(response.data);
      setLoading(false);
      return response;
    }

    fetchData();
  }, []);

  const hitRecipes = recipes.filter((recipe, ) => {
    if (recipe.level === level && recipe.situation === situation && recipe.cookTimeRange === cookTimeRange) {
      return true;
    }
    return false;
  })

  return (
    <>
      <Typography variant="h5" color="inherit" conponent="div">そんなあなたにオススメのレシピはこちらです！</Typography>
      <br />
      <Grid container alignItems="center" justify="center">
        <Grid item xs={8}>
          <Watch height={200} width={200} color="pink" ariaLabel="loading-indicator" visible={loading} />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
      {
        (hitRecipes.length >= 1 || loading) ? (
        hitRecipes.map((hitRecipe)=>{
          return <ResultRecipe hitRecipe={hitRecipe} />
        })
        ) : (
          <>
            <br />
            <Grid container>
              <Grid item xs={12}>
                <Typography variant='h6' color='inherit' component='div'>ごめんなさい。条件に合うレシピは見つかりませんでした</Typography>
              </Grid>
            </Grid>
          </>
        )
      }
      </Grid>
    </>
  );
}

export default App;